import { useContext, useEffect } from "react";
import { useFormik } from "formik";
import { MenuItem, InputBase, Button, Select, useTheme } from "@material-ui/core";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@material-ui/icons";
import clsx from "clsx";
import * as Yup from "yup";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import ls from "local-storage";
import { useLocation } from "react-router-dom";

import { useThemeStyles } from "../../../styles/themes";

import { StoreContext } from "../../../store/context";

const styles = {
  divider: {
    margin: "16px 0px"
  },
};

const validationSchema = Yup.object().shape({
  applicationId: Yup.string(),
  bankId: Yup.string().nullable().required("This is a required field"),
});

const LinkBankAccount = (props) => {
  const { analyticsStep } = props;

  const params = new URLSearchParams(useLocation().search);
  const classes = useThemeStyles();
  const theme = useTheme();
  const { state, actions } = useContext(StoreContext);
  const formik = useFormik({
    initialValues: {
      applicationId: state.applicationId,
      bankId: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const data = {
        ...values
      };

      ls.set("bnplstate", state);

      // AnalyticsStep: End step
      analyticsStep.handleStepEnd();

      data.checkoutUrl = `${window.location.href.split("?")[0]}?step=8&embedded=${params.get("embedded")}`;
      actions.initialMandate(data);
    },
  });

  useEffect(() => {
    actions.getBankList();
  }, []);

  return (
    <>
      <div style={{ marginTop: "12px" }}>
        <p className={`${classes.title}`} style={{ color: theme.colors.colorPrimaryDarker }}>Link Bank Account</p>
        <p className={`${classes.subtitle} sub-title`} style={{ marginTop: "18px", marginBottom: "20px", color: theme.colors.colorPrimaryDarker }}>Your selected bank account will be used to automatically collect your upcoming repayment(s).</p>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="form-control-holder">
          <p className="form-title">Bank Name</p>
          <Select
            IconComponent={(props) => <KeyboardArrowDownIcon {...props} style={{ top: "calc(50% - 12px)" }} />}
            id="bankId"
            name="bankId"
            displayEmpty
            className={clsx({ placeholder: !formik.values.bankId })}
            onChange={formik.handleChange}
            value={formik.values.bankId}
            style={{ width: "100%", paddingTop: "16px", paddingBottom: "12px" }}
          >
            <MenuItem value="" disabled>Select Bank</MenuItem>
            {state.banks?.map((item, i) => <MenuItem key={`banks${i}`} value={item.id}>{item.name}</MenuItem>)}
          </Select>
          {/* <Select
            IconComponent={KeyboardArrowDownIcon}
            id="bankId"
            name="bankId"
            displayEmpty
            className={clsx("form-input form-select-input", classes.inputSelectBox,
              { placeholder: !formik.values.bankId },
              { "form-error-border": formik.touched.bankId && formik.errors.bankId })}
            onChange={formik.handleChange}
            value={formik.values.bankId}
            input={<InputBase />}
          >
            <MenuItem value="" disabled>Select Bank</MenuItem>
            {state.banks?.map((item, i) => <MenuItem key={`banks${i}`} value={item.id}>{item.name}</MenuItem>)}
          </Select> */}
          {formik.touched.bankId && formik.errors.bankId
            ? (<span className="form-error">{formik.errors.bankId}</span>) : null}
        </div>

        <div className={`${classes.divider} divider`} style={styles.divider} />

        <p className="small">
          <b>NOTE:</b>
          <br />
          RM 1.00 (non-refundable) will be deducted to verify and link your bank account.
        </p>

        <div className={`${classes.divider} divider`} style={styles.divider} />

        <div className="action-holder" style={{ marginTop: "24px" }}>
          <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" type="submit">
            Continue to FPX Verification
          </Button>
        </div>
      </form>
    </>
  );
};

export default withUbdAnalyticsStep(LinkBankAccount, {
  stepId: "LinkBankAccount",
  capturingFieldNames: [],
});
